import React from 'react';
import BrandMark from '../brand/BrandMark';

function BrandLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 text-gray-900 dark:bg-neutral-950 dark:text-neutral-100">
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto mb-5 flex w-fit items-center justify-center">
          <div className="relative">
            <div className="absolute inset-[-10px] rounded-3xl border-2 border-blue-200 border-t-blue-600 dark:border-neutral-800 dark:border-t-blue-400 animate-spin" />
            <BrandMark size="lg" />
          </div>
        </div>
        <div className="mx-auto flex w-28 gap-1.5">
          <span className="h-1.5 flex-1 rounded-full bg-blue-600 animate-pulse" />
          <span className="h-1.5 flex-1 rounded-full bg-blue-300 animate-pulse [animation-delay:120ms]" />
          <span className="h-1.5 flex-1 rounded-full bg-blue-100 animate-pulse [animation-delay:240ms]" />
        </div>
      </div>
    </div>
  );
}

export default BrandLoader;
